<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="openAdd()"
        >添加</el-button
      >
      <!-- <el-button type="danger" size="mini"  @click="open"
        >删除</el-button
      > -->
      <el-button type="success" size="mini" @click="getList">刷新</el-button>
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">乙方名称</label>
        <el-input
          v-model="name"
          placeholder="请输入乙方名称"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号</label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">备注</label>
        <el-input
          v-model="memo"
          placeholder="请输入备注"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1811px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="乙方名称" width="100" />
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="address" label="是否启用" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isEnabled" style="color: #06cc00">启用</div>
          <div v-if="!scope.row.isEnabled" style="color: red">禁用</div>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="address" label="开始域名" width="170">
        <template slot-scope="scope">
          <div>
            <span style="margin-right: 8px;background: #6663FF;color: #FFF;font-size: 14px;padding: 4px 10px;" v-for="tag in scope.row.startDomains" :key="tag">{{tag}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="注册域名" width="170">
        <template slot-scope="scope">
          <div>
            <span style="margin-right: 8px;background: #6663FF;color: #FFF;font-size: 14px;padding: 4px 10px;" v-for="tag in scope.row.registerDomains" :key="tag">{{tag}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="登入域名" width="170">
        <template slot-scope="scope">
          <div>
            <span style="margin-right: 8px;background: #6663FF;color: #FFF;font-size: 14px;padding: 4px 10px;" v-for="tag in scope.row.loginDomains" :key="tag">{{tag}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="telegram" label="专属Telegram" width="150" />
      <el-table-column prop="whatsApp" label="专属WhatsApp" width="150" />
      <el-table-column prop="messenger" label="专属Messenger" width="150" />
      <el-table-column prop="instagram" label="专属instagram" width="150" />
      <el-table-column prop="linkUrl" label="专属客服链接" width="150" />
      <el-table-column
        prop="telegramGroup"
        label="专属Telegram频道组"
        width="170"
      />
      <el-table-column prop="tgroupUrl" label="进群链接" width="150" />
      <el-table-column
        prop="indexMidPath"
        label="社交平台群组外链"
        width="170"
      />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加弹窗 -->

    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="乙方名称">
          <el-input v-model="active.name" placeholder="请输入乙方名称" />
        </el-form-item>
        <el-form-item label="账号" prop="count">
          <el-input v-model="active.username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码" prop="count">
          <el-input v-model="active.password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="设置" prop="count">
          <el-checkbox v-model="isEnabled">是否启用</el-checkbox>
          <el-checkbox style="margin-left: 10px" v-model="isChat"
            >是否显示在线聊天</el-checkbox
          >
        </el-form-item>
        <el-form-item label="备注" prop="count">
          <el-input v-model="active.memo" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="开始域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in startDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue(tag)"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible"
                ref="saveTagInput"
                v-model="inputValue"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="注册域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in registerDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue1(tag)"
                @close="handleClose1(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible1"
                ref="saveTagInput1"
                v-model="inputValue1"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm1"
                @blur="handleInputConfirm1"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput1"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="登录域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in loginDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue2(tag)"
                @close="handleClose2(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible2"
                ref="saveTagInput2"
                v-model="inputValue2"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm2"
                @blur="handleInputConfirm2"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput2"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>

        <el-form-item label="专属Telegram">
          <el-input
            v-model="active.telegram"
            placeholder="请输入专属Telegram"
          />
          <el-checkbox style="margin-left: 20px" v-model="isTelegram"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属WhatsApp">
          <el-input
            v-model="active.whatsApp"
            placeholder="请输入专属WhatsApp"
          />
          <el-checkbox style="margin-left: 20px" v-model="isWhatsApp"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属Messenger">
          <el-input
            v-model="active.messenger"
            placeholder="请输入专属Messenger"
          />
          <el-checkbox style="margin-left: 20px" v-model="isMessenger"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属instagram">
          <el-input
            v-model="active.instagram"
            placeholder="请输入专属instagram"
          />
          <el-checkbox style="margin-left: 20px" v-model="isInstagram"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属客服链接">
          <el-input v-model="active.linkUrl" placeholder="请输入专属客服链接" />
          <el-checkbox style="margin-left: 20px" v-model="isLinkUrl"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属Telegram频道组">
          <el-input
            v-model="active.telegramGroup"
            placeholder="请输入专属Telegram频道组"
          />
          <el-checkbox style="margin-left: 20px" v-model="isTelegramGroup"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="进群链接">
          <el-input
            v-model="active.tgroupUrl"
            placeholder="请输入进群链接"
          />
        </el-form-item>
        <el-form-item label="社交平台群组外链">
          <el-input
            v-model="active.indexMidPath"
            placeholder="请输入社交平台群组外链"
          />
          <!-- <el-checkbox style="margin-left: 20px;" v-model="isTelegramGroup">是否显示</el-checkbox> -->
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="addManagement()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="1000px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="乙方名称">
          <el-input v-model="editForm.name" placeholder="请输入乙方名称" />
        </el-form-item>
        <el-form-item label="账号" prop="count">
          <el-input v-model="editForm.username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码" prop="count">
          <el-input v-model="editForm.password" placeholder="请输入密码" />
          <span style="color: red; margin-left: 10px">留空表示不修改</span>
        </el-form-item>
        <el-form-item label="设置" prop="count">
          <el-checkbox v-model="editForm.isEnabled">是否启用</el-checkbox>
          <el-checkbox style="margin-left: 10px" v-model="editForm.isChat"
            >是否显示在线聊天</el-checkbox
          >
        </el-form-item>
        <el-form-item label="备注" prop="count">
          <el-input v-model="editForm.memo" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="开始域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in startDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue(tag)"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible"
                ref="saveTagInput"
                v-model="inputValue"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="注册域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in registerDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue1(tag)"
                @close="handleClose1(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible1"
                ref="saveTagInput1"
                v-model="inputValue1"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm1"
                @blur="handleInputConfirm1"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput1"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="登录域名" prop="count">
          <div>
            <div style="display: flex; flex-wrap: wrap; align-items: baseline">
              <el-tag
                v-for="tag in loginDomains"
                :key="tag"
                style="margin-right: 8px;"
                closable
                :disable-transitions="false"
                @click="changeValue2(tag)"
                @close="handleClose2(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div style="margin-top: 8px;">
              <el-input
                v-if="inputVisible2"
                ref="saveTagInput2"
                v-model="inputValue2"
                class="input-new-tag"
                type="textarea"
                size="small"
                style="width: 300px"
                @keyup.enter.native="handleInputConfirm2"
                @blur="handleInputConfirm2"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput2"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>

        <el-form-item label="专属Telegram">
          <el-input
            v-model="editForm.telegram"
            placeholder="请输入专属Telegram"
          />
          <el-checkbox style="margin-left: 20px" v-model="editForm.isTelegram"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属WhatsApp">
          <el-input
            v-model="editForm.whatsApp"
            placeholder="请输入专属WhatsApp"
          />
          <el-checkbox style="margin-left: 20px" v-model="editForm.isWhatsApp"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属Messenger">
          <el-input
            v-model="editForm.messenger"
            placeholder="请输入专属Messenger"
          />
          <el-checkbox style="margin-left: 20px" v-model="editForm.isMessenger"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属instagram">
          <el-input
            v-model="editForm.instagram"
            placeholder="请输入专属instagram"
          />
          <el-checkbox style="margin-left: 20px" v-model="editForm.isInstagram"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属客服链接">
          <el-input
            v-model="editForm.linkUrl"
            placeholder="请输入专属客服链接"
          />
          <el-checkbox style="margin-left: 20px" v-model="editForm.isLinkUrl"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="专属Telegram频道组">
          <el-input
            v-model="editForm.telegramGroup"
            placeholder="请输入专属Telegram频道组"
          />
          <el-checkbox
            style="margin-left: 20px"
            v-model="editForm.isTelegramGroup"
            >是否显示</el-checkbox
          >
        </el-form-item>
        <el-form-item label="进群链接">
          <el-input
            v-model="editForm.tgroupUrl"
            placeholder="请输入进群链接"
          />
        </el-form-item>
        <el-form-item label="社交平台群组外链">
          <el-input
            v-model="editForm.indexMidPath"
            placeholder="请输入社交平台群组外链"
          />
          <!-- <el-checkbox style="margin-left: 20px;" v-model="isTelegramGroup">是否显示</el-checkbox> -->
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="editManagement()">
            <el-button slot="reference" type="primary" class="edit-button"
              >更新</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: {},
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      name: "",
      username: "",
      memo: "",
      isEnabled: false,
      isChat: false,
      isTelegram: false,
      isWhatsApp: false,
      isMessenger: false,
      isInstagram: false,
      isLinkUrl: false,
      isTelegramGroup: false,

      startDomains: [],
      inputVisible: false,
      inputValue: "",
      isChange: false,
      tempTag: '',
      registerDomains: [],
      inputVisible1: false,
      inputValue1: "",
      isChange1: false,
      tempTag1: '',
      loginDomains: [],
      inputVisible2: false,
      inputValue2: "",
      isChange2: false,
      tempTag2: '',
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 开始域名
    showInput() {
      this.inputVisible = true;
      this.inputValue = "";
      this.isChange = false;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      // 判断是否修改原有值，是 替换修改好的值，否新增
      if (this.isChange) {
        this.startDomains[
          this.startDomains.indexOf(this.tempTag)
        ] = this.inputValue;
        this.inputVisible = false;
        return;
      }
      if (inputValue) {
        this.startDomains.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    changeValue(tag) {
      this.inputVisible = true;
      this.inputValue = tag;
      this.tempTag = tag;
      this.isChange = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.focus();
      });
    },
    handleClose(tag) {
      this.startDomains.splice(this.startDomains.indexOf(tag),1);
    },
    // 注册域名
    showInput1() {
      this.inputVisible1 = true;
      this.inputValue1 = "";
      this.isChange1 = false;
      this.$nextTick((_) => {
        this.$refs.saveTagInput1.focus();
      });
    },
    handleInputConfirm1() {
      const inputValue = this.inputValue1;
      if (this.isChange1) {
        this.registerDomains[this.registerDomains.indexOf(this.tempTag1) ] = this.inputValue1;
        this.inputVisible1 = false;
        return;
      }
      if (inputValue) {
        this.registerDomains.push(inputValue);
      }
      this.inputVisible1 = false;
      this.inputValue1 = "";
    },
    changeValue1(tag) {
      this.inputVisible1 = true;
      this.inputValue1 = tag;
      this.tempTag1 = tag;
      this.isChange1 = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput1.focus();
      });
    },
    handleClose1(tag) {
      this.registerDomains.splice(this.startDomains.indexOf(tag),1);
    },
    // 登录域名
    showInput2() {
      this.inputVisible2 = true;
      this.inputValue2 = "";
      this.isChange2 = false;
      this.$nextTick((_) => {
        this.$refs.saveTagInput2.focus();
      });
    },
    handleInputConfirm2() {
      const inputValue = this.inputValue2;
      if (this.isChange2) {
        this.loginDomains[this.loginDomains.indexOf(this.tempTag2) ] = this.inputValue2;
        this.inputVisible2 = false;
        return;
      }
      if (inputValue) {
        this.loginDomains.push(inputValue);
      }
      this.inputVisible2 = false;
      this.inputValue2 = "";
    },
    changeValue2(tag) {
      this.inputVisible2 = true;
      this.inputValue2 = tag;
      this.tempTag2 = tag;
      this.isChange2 = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput2.focus();
      });
    },
    handleClose2(tag) {
      this.loginDomains.splice(this.loginDomains.indexOf(tag),1);
    },
    //
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        name: this.name,
        username: this.username,
        memo: this.memo,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .yiFangList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .message2Delete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开新增弹窗
    openAdd() {
      this.dialogVisible = true;
      this.active.isEnabled = false;
      this.active.isTelegram = false;
      this.active.isWhatsApp = false;
      this.active.isMessenger = false;
      this.active.isInstagram = false;
      this.active.isLinkUrl = false;
      this.active.isTelegramGroup = false;
      this.startDomains = []
      this.registerDomains = []
      this.startDomains = []
    },
    // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.startDomains = this.editForm.startDomains
      this.registerDomains = this.editForm.registerDomains
      this.loginDomains = this.editForm.loginDomains
      this.edit_dialogVisible = true;
    },
    // 添加用户
    addManagement() {
      this.active.isChat = this.isChat;
      this.active.isEnabled = this.isEnabled;
      this.active.isTelegram = this.isTelegram;
      this.active.isWhatsApp = this.isWhatsApp;
      this.active.isMessenger = this.isMessenger;
      this.active.isInstagram = this.isInstagram;
      this.active.startDomains = this.startDomains;
      this.active.registerDomains = this.registerDomains;
      this.active.loginDomains = this.loginDomains;
      this.active.isLinkUrl = this.isLinkUrl;
      this.active.isTelegramGroup = this.isTelegramGroup;
      this.$api.operate
        .yiFangSave(this.active)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 更新用户信息
    editManagement() {
      console.log(this.startDomains)
      console.log(this.registerDomains)
      console.log(this.loginDomains)
      this.editForm.startDomains = this.startDomains?this.startDomains:null;
      this.editForm.registerDomains = this.registerDomains?this.registerDomains:null;
      this.editForm.loginDomains = this.loginDomains?this.loginDomains:null;
      this.$api.operate 
        .yiFangUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner {
  padding: 0 8px !important;
}
</style>
